/**
 * @desc 导入模板
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** baseId */
  baseId?: string;
  /** roleId */
  roleId?: number;
}

export function request(
  params: Params,
): Promise<defs.StandardReturn<defs.ObjectMap<string, string>>> {
  return defHttp.post({
    url: '/web/user/uploadTemplate',

    params,
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<defs.ObjectMap<string, string>>> {
  return defHttp.post({
    url: '/mock/web/user/uploadTemplate',

    params,
  });
}
